// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"623":"255c9775","670":"bf619477","787":"30e837d5"}[chunkId] + ".chunk.js";
};